import Input from "../Input/Input";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../Snackbar/Snackbar";
import { editCustomer, getCustomer } from "../../features/admin/adminSlice";
import Button from "../Button/Button";
import { NavLink } from "react-router-dom";
import { areFieldsNotEmpty, isEmptyFields } from "../../helpers/helper";
import Calendar from "../Calendar/Calendar";
import { dateToServer, serverToLocal } from "../../utils/date";
import { phoneNumber } from "../../utils/payment";
import { useMyContextLoading } from "../LoadingContextProvider/LoadingContextProvider";

const GeneralTab = () => {
  const dispatch = useDispatch();
  const { triggerLoading } = useMyContextLoading();
  const [reqError, setReqError] = useState('');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    primaryPhone: '',
    address: '',
    aptNumber: '',
    city: '',
    state: '',
    zip: '',
    dateOfBirth: '',

  });
  const currentURL = window.location.href;
  const parts = currentURL.split('/');
  const userId = parts[parts?.length - 1];


  useEffect(() => {
    const handleReqError = () => {
      reqError?.length > 0 && showSnackBar("error", reqError)
      setReqError('')
    }

    handleReqError()
  }, [reqError]);
  const handleEditCustomer = async () => {
    const newNumber = formData?.primaryPhone?.replace(/\D/g, "")
    const response = await dispatch(editCustomer({
      customerId: userId,
      userData: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        primaryPhone: newNumber,
        dateOfBirth: dateToServer(formData.dateOfBirth),
        address: formData.address,
        aptNumber: formData.aptNumber,
        city: formData.city,
        state: formData.state,
        zip: formData.zip,
      }
    }));
    if (response.error) {
      setReqError(response.payload);
    } else if (response) {
      showSnackBar("success", "Your changes are saved")
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        primaryPhone: '',
        address: '',
        aptNumber: '',
        city: '',
        state: '',
        zip: '',
        dateOfBirth: '',
      }
      )
    }
  };
  const getCustomerById = async () => {
    triggerLoading(true)
    try {
      const response = await dispatch(getCustomer(userId));
      setFormData({
        firstName: response?.payload?.data?.firstName || '',
        lastName: response?.payload?.data?.lastName || '',
        email: response?.payload?.data?.email || '',
        primaryPhone: phoneNumber(response?.payload?.data?.primaryPhone) || '',
        address: response?.payload?.data?.address?.address || '',
        aptNumber: response?.payload?.data?.address?.aptNumber || '',
        city: response?.payload?.data?.address?.city || '',
        state: response?.payload?.data?.address?.state || '',
        zip: response?.payload?.data?.address?.zip || '',
        dateOfBirth: serverToLocal(response?.payload?.data?.dateOfBirth) || '',
      })

    } catch (error) {
      console.error(error);
      setReqError(error.message || 'Failed to get customer data');
    }
    triggerLoading(false)
  }

  useEffect(() => {
    getCustomerById()
  }, []);
  const handleInputChange = ({ name, value }) => {
    switch (name) {
      case 'primaryPhone':
        setFormData((prevData) => ({ ...prevData, [name]: phoneNumber(value) }))
        break;
      default:
        setFormData((prevData) => ({ ...prevData, [name]: value }))
        break;
    }
  };
  return (
    <div className="flex  w-full items-center justify-center">
      {/*<AddAvatar/>*/}
      <div className=" w-full max-w-[850px] rounded-2xl shadow-card p-12">
        <div className="grid grid-cols-2 gap-x-4 gap-y-6 pb-6 h-max border-b border-divider ">
          <Input width="w-full" placeholder="Enter First Name" label="First name *" value={formData.firstName}
            onChange={(e) => handleInputChange({ name: 'firstName', value: e.target.value })} />
          <Input width="w-full" placeholder="Enter Last Name" label="Last name *" value={formData.lastName}
            onChange={(e) => handleInputChange({ name: 'lastName', value: e.target.value })} />
          <Input width="w-full" placeholder="Enter Primary Phone" label="Primary Phone" value={formData.primaryPhone}
            onChange={(e) => handleInputChange({ name: 'primaryPhone', value: e.target.value })} />
          <Input type="email" width="w-full" placeholder="Enter Email" label="Email *" value={formData.email}
            onChange={(e) => handleInputChange({ name: 'email', value: e.target.value })} />
          <Input width="w-full" placeholder="Enter Address" label="Address" value={formData.address}
            onChange={(e) => handleInputChange({ name: 'address', value: e.target.value })} />
          <Input width="w-full" placeholder="34" label="Suite/Apt#" value={formData.aptNumber}
            onChange={(e) => handleInputChange({ name: 'aptNumber', value: e.target.value })} />
          <Input width="w-full" placeholder="Enter City" label="City" value={formData.city}
            onChange={(e) => handleInputChange({ name: 'city', value: e.target.value })} />
          <Input width="w-full" placeholder="Enter State" label="State" value={formData?.state}
            onChange={(e) => handleInputChange({ name: 'state', value: e.target.value })} />
          <Input width="w-full" placeholder="Enter Zip" label="Zip" value={formData?.zip}
            onChange={(e) => handleInputChange({ name: 'zip', value: e.target.value })} />
          <Calendar
            width="w-full"
            label="Date Of Birth *"
            optional
            value={formData.dateOfBirth}
            onChange={(e) => handleInputChange({ name: 'dateOfBirth', value: e })}
            errorMsg={isEmptyFields(formData?.dateOfBirth) ? 'This field is required' : ''}
            isRequired={true}
          />
        </div>
        <div className={`mt-6 flex justify-end space-x-4`}>
          <NavLink to={"/"} >
            <Button classes={"mr-4"} onClick={() => { }} type="outlined" size="lg" width="min-w-[156px]">Close</Button>
          </NavLink>
          <NavLink to="/customers">
            <Button onClick={handleEditCustomer} size="lg" width="min-w-[156px]" disabled={!areFieldsNotEmpty([formData.firstName, formData.lastName, formData.email, formData.ssNumber]) || formData.dateOfBirth === ''}
              classes="rounded-lg">Save</Button>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default GeneralTab;
